import { render, staticRenderFns } from "./footer-app.html?vue&type=template&id=9cfcd824&scoped=true&"
import script from "./footer-app.vue?vue&type=script&lang=js&"
export * from "./footer-app.vue?vue&type=script&lang=js&"
import style0 from "./footer-app.less?vue&type=style&index=0&id=9cfcd824&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cfcd824",
  null
  
)

export default component.exports